import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PopupButton, InlineWidget } from "react-calendly";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupsIcon from '@mui/icons-material/Groups';
import ScienceIcon from '@mui/icons-material/Science';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import SpeedIcon from '@mui/icons-material/Speed';
import BuildIcon from '@mui/icons-material/Build';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Stack from '@mui/material/Stack';
import Hidden from '@mui/material/Hidden';
import ContactForm from './ContactForm';

import StreamLocatorLogo from './../../StreamLocator_logo.png';
import SMSLiveLogo from './../../smsliveLogo.png';
import StreamLocatorLogoGrey from './../../StreamLocator_logoGrey.png';
import SMSLiveLogoGrey from './../../smsliveLogoGrey.png';
import PBPLogoGrey from './../../pbp_logo_200Grey.png';
import EmergeLogoGrey from './../../emergeLogoGrey.png';
import ConnectionsLogos from './../../ConnectionsLogos.png';

import Header from './Header';
import Footer from './Footer';
import FloSQLForm from './FloSQLForm';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
    justifyContent: 'left',
    justify: 'left',
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  text: {
    margin: theme.spacing(1),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardContent: {
    backgroundColor: 'white',
    color: '#0284c7'
  },
}));

const tiers = [
  {
    title: 'START YOUR 14-DAY FREE TRIAL',
    subheader: 'START BUILDING DATA PIPELINES ON TOP OF YOUR DATA WAREHOUSE.',
    price: '$0',
    value: '',
    description: [
    'Completely managed Apache Airflow instance',
    'Automatic dependency mapping',
    'Templates and variables for easy coding',
    'Validations for upstream data errors',
    'Up to 3 users',
    '1000 successful tasks',
    'Snowflake integration',
    'Github SSO',
    'Hosted Redash Dashboarding',
    'Email support',],
    buttonText: 'Start Free Trial',
    buttonVariant: 'outlined',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7'
    },
    style: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7'
    }
  },
];

const data_warehouses = [
  { title: 'Snowflake'},
  { title: 'Amazon Redshift'},
  { title: 'Google BigQuery'},
  { title: 'Microsoft Azure'},
  { title: 'Other'},
  ];

export default function RequestDemo() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>
      	<Container maxWidth="lg" component="main" className={classes.heroContent}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:10}}
        >
        </Box>
          <form>
          <Hidden smDown><Box style={{padding:50}}></Box></Hidden>
        <Hidden mdUp><Box style={{padding:20}}></Box></Hidden>
        <Grid container direction={'row'} alignItems="flex" >
        <Grid
            item
            container
            direction="column"
            alignItems="flex-start"
            justify="center" xs={12} sm={12} md={8} lg={8}
            >
        {/*<Box style={{padding:60}}></Box>*/}
        <Typography component="h1" variant="h3" style={{ padding:5, fontWeight: 'bold', fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textPrimary" >
          Explore FloSQL with an expert
        </Typography>
        <Hidden smDown>
        <Box style={{padding:20}}></Box>
        <Typography component="h1" variant="h6" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textSecondary" >
          Get easily accessible and manageable data that fits your company's unique requirements.
          FloSQL sets up your data stack and helps you take control of your data.
        </Typography>
        <Box style={{padding:10}}></Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <JoinFullIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Join 100s of Sources</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <AllInclusiveIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', paddingLeft:10}} align="center" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >Scales with your growth</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <BuildIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Customizable to your needs</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <SpeedIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="left" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Leverage the scale of Apache Airflow</Box>
        </Typography>
        </Box>
        {/*<Box style={{padding:10}}></Box>*/}
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <ScienceIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Build in predictive capabilities</Box>
        </Typography>
        </Box>
        </Hidden>
        <Box style={{padding:20}}></Box>
        {/*<Box
          display="flex"
          alignItems="left"
          justifyContent="left"
          style={{padding:40}}
          >*/}
          {/*<Box className={classes.button} >
            <Button size="large" href='/LearnMore' variant="outlined" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >Learn More</Button>
          </Box>*/}
          {/*<Box style={{padding:10}}></Box>*/}
          {/*<Box className={classes.button}>
            <Button size="large" href='https://www.flosql.com/?utm_source=referral&utm_medium=website&utm_campaign=base13header' variant="outlined" style={{color: "#0284c7", borderColor:"#0284c7", textTransform: 'none'}} startIcon={<img src={FloSQLIcon} style={{ maxWidth:25 }} />} target="_blank">Go to FloSQL</Button>
          </Box>*/}
          {/*</Box>*/}
          <Hidden mdUp>
            <Grid container alignItems="flex-end" >
            <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
            <Typography component="h5" variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="center" justify="center" color="textSecondary" >
              Effective data teams use FloSQL
            </Typography>

            <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:20}}
            >
              <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoGrey}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoGrey}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoGrey}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoGrey}/>

            </Stack>
            </Grid>
            </Grid>
            </Hidden>

        </Grid>
        {/*<Box style={{padding:50}}></Box>*/}
        <Grid item
            container
            alignItems="flex"
            justify="center"
            xs={12} sm={12} md={4} lg={4}
            // paddingRight={25}
            >
            <Paper elevation={3}>
        <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:30}}
              >
                <ContactForm />
              </Box>
              </Paper >
        </Grid>
        </Grid>

       <Box style={{padding:50}}></Box>
       <Hidden smDown>
        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
        <Typography component="h5" variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="center" justify="center" color="textSecondary" >
          Effective data teams use FloSQL
        </Typography>

        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
          <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoGrey}/>

        </Stack>
        </Grid>
        </Grid>




        <Box style={{padding:50}}></Box>
        </Hidden>

          {/*<Grid container alignItems="flex-end" spacing={2}>
            <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end" style={{ padding: 20 }}>*/}
              {/*<InlineWidget
                pageSettings={{
                  backgroundColor: 'ffffff',
                  hideEventTypeDetails: false,
                  hideGdprBanner: true,
                  hideLandingPageDetails: false,
                  primaryColor: '00a2ff',
                  textColor: '4d5055'
                }}
                prefill={{
                  customAnswers: {
                  },
                }}
                styles={{
                  height: '1000px'
                }}
                url="https://calendly.com/base13labs/flosql-demo"
                utm={{
                  utmCampaign: 'Data Orchestration',
                  utmContent: 'Request Demo',
                  utmMedium: 'Website',
                  utmSource: 'Base13 Labs',
                  utmTerm: ''
                }}
              />*/}
            {/*</Grid>
           </Grid>*/}

              {/*<Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:0}}
                >
                <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdXVCg45w2vgiFghAO3t4Km47tdQqg3y622hjgFR6zB5fTF8Q/viewform?embedded=true" width="560" height="2379" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                </Box>*/}
          </form>
      	</Container>
      <Footer/>
    </React.Fragment>
  );
}